export enum MESSAGES_VARIANT {
  NEW_MESSAGE = 'new message',
  NO_MESSAGE = 'no message',
}

export enum NOTIFICATION_VARIANT {
  NEW_NOTIFICATION = 'new notification',
  NO_NOTIFICATION = 'no notification',
}
